import { FC, useState } from 'react'
import { Button, FlexboxGrid, Loader, Panel } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'

import NoOrderListsIcon from './NoOrderListsIcon'
import useIsOnMobile from '../../../../services/useIsOnMobile'
import AddIcon from '../../../Icons/BuyerPortal/AddIcon'
import { DARK_GREY_COLOR, ScreenSize } from '../../../../utils/constants'
import BrowseProducts from '../../../BrowseProducts'

import styles from '../../../../styles/BuyerPortal/CatalogEmptyStates.module.less'

const CatalogModal = dynamic(() => import('../CatalogModal'))

interface NoCatalogStateProps {
  headerText: string
  messageText: string
  isLoading?: boolean
  isOnCatalogDetailPage?: boolean
}

const NoCatalogState: FC<NoCatalogStateProps> = (props) => {
  const {
    headerText,
    messageText,
    isLoading = false,
    isOnCatalogDetailPage = false,
  } = props

  const [isCatalogModalOpen, setIsCatalogModalOpen] = useState(false)

  const isOnMobile = useIsOnMobile(ScreenSize.md)
  const { t } = useTranslation('buyerProfile')

  return (
    //  Below div container with class name is used for onboarding tool CSS selector
    <div className="catalog-table-container">
      <Panel
        bordered
        className={styles['empty-state-panel']}
      >
        {isLoading ? (
          <Loader size="lg" />
        ) : (
          <>
            <NoOrderListsIcon />
            <h4 className="margin-bottom-spacer">{headerText}</h4>
            <p>{messageText}</p>
            {isOnCatalogDetailPage ? <BrowseProducts /> : (
              <Button
                appearance="primary"
                data-testid="no-catalog-create-catalog-button"
                className={styles['new-catalog-button']}
                onClick={() => setIsCatalogModalOpen(true)}
                block={isOnMobile}
              >
                <FlexboxGrid
                  align="middle"
                  justify="center"
                >
                  <AddIcon
                    size="16"
                    fill={DARK_GREY_COLOR}
                  />
                  <b className="margin-left-spacer">{t('Create new catalog')}</b>
                </FlexboxGrid>
              </Button>
            )}

          </>
        )}
      </Panel>
      {isCatalogModalOpen && (
        <CatalogModal
          action="create"
          catalogName={null}
          setIsCatalogModalOpen={setIsCatalogModalOpen}
        />
      )}
    </div>
  )
}

export default NoCatalogState
